const paths = {
  base_url: "https://www.reddit.com",
};

export default paths;
